export default "__VITE_ASSET__DCLduNvK__"